import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import useLogout from '../../Hooks/useLogout';
import styles from "./NavBar.module.css";
import useData from "../../Hooks/useData";
import SideNav from "../SideNav/SideNav";

export const NavBar = ({ user, profilePicture }) => {
  const navigate = useNavigate();
  const { logout } = useData();
  const logoutHook = useLogout();

  const signout = async () => {
    try {
      
      // Call the logout hook to handle API logout if needed
      await logoutHook();
      
      // Call the context logout to clear local state and localStorage
      logout();
      
      // Navigate to login page
      navigate("/login", { replace: true });
    } catch (error) {
      // Even if API logout fails, still clear local state
      logout();
      navigate("/login", { replace: true });
    }
  }

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  }

  const closeMenu = () => {
    setIsMenuOpen(false);
  }



  return user?.user?.FirstName ? (
    <>
      {/* Menu Overlay */}
      <div 
        className={`${styles.menuOverlay} ${isMenuOpen ? styles.open : ''}`}
        onClick={closeMenu}
      ></div>

      {/* Slide Menu */}
      <div className={`${styles.slideMenu} ${isMenuOpen ? styles.open : ''}`}>
        <button className={styles.closeButton} onClick={closeMenu}>×</button>
        <SideNav user={user} profilePicture={profilePicture} onNavigate={closeMenu} />
      </div>

      <div className={styles.Nav}>
        <div className="d-sm-block d-xs-block d-md-block d-lg-none">
          <div className={styles.sidebarToggle} onClick={toggleMenu}>
            <div> 
              <span className={`${styles.top}`}></span> 
              <span className={`${styles.middle}`}></span> 
              <span className={`${styles.bottom}`}></span> 
            </div>
          </div>
        </div>

        <div className="tag d-none d-lg-block d-xl-block">Meeting needs in Jesus' name</div>
        <Button
          variant="contained"
          className={styles.signOutBtn}
          onClick={signout}
          sx={{
            backgroundColor: "error.main",
            borderRadius: "0",
            fontWeight: "bold",
            fontFamily: "inherit",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },

          }}
        >
          Sign Out
        </Button>
      </div>
    </>
  ) : (
    <>
      {/* Menu Overlay */}
      <div 
        className={`${styles.menuOverlay} ${isMenuOpen ? styles.open : ''}`}
        onClick={closeMenu}
      ></div>

      {/* Slide Menu */}
      <div className={`${styles.slideMenu} ${isMenuOpen ? styles.open : ''}`}>
        <button className={styles.closeButton} onClick={closeMenu}>×</button>
        <SideNav user={user} profilePicture={profilePicture} onNavigate={closeMenu} />
      </div>

      <nav className="sb-topnav navbar navbar-expand navbar-dark bg-blue">
        <div className="d-sm-block d-xs-block d-md-block d-lg-none">
          <div className={styles.sidebarToggle} onClick={toggleMenu}>
            <div> 
              <span className={`${styles.top}`}></span> 
              <span className={`${styles.middle}`}></span> 
              <span className={`${styles.bottom}`}></span> 
            </div>
          </div>
        </div>
        <div className="tag d-none d-lg-block d-xl-block">Sharing God's Love in Word and Deed</div>
        <div className="log-out">
          <Link to='/login'>Sign In</Link>
        </div>
      </nav>
    </>
  );
}
